type NavLinkDLPropsType = {
  path: string;
  btnText: string;
};

export const navLinkDataLayer = ({ path, btnText }: NavLinkDLPropsType) => {
  window.dataLayer.push({
    event: "navigation",
    navigation_name: "header",
    navigation_url: path,
    navigation_text: btnText,
    navigation_category: btnText,
  });
};
/**
 * ``navLinkDataLayerSignIn``
 */
export const navLinkDLSignIn = ({ distinctId }: { distinctId: string }) => {
  window.dataLayer.push({ event: "sign_in", user_id: distinctId });
};
